import { Contact } from '.';
import { FieldDelimiter } from './fields';

export enum OutputTargetParty {
  Client = 'Client',
  ThirdParty = 'Third Party',
}
export interface DeliveryFileInfo {
  isNeeded: boolean;
  name?: string;
}
export interface OutputLocation {
  target: OutputTargetParty;
  delimiter: FieldDelimiter;
  mainFile?: DeliveryFileInfo;
  rejectFile?: DeliveryFileInfo;
  statementFile?: DeliveryFileInfo;
  zippedFile?: DeliveryFileInfo;
  location: string;
  contact?: Contact;
}
